import React from "react";
import img from "../../assets/144131.jpg"; // replace with your actual image

const AboutOne = () => {
  return (
    <section className="w-full bg-gray-50 py-16 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto flex flex-col gap-12">
        {/* Breadcrumb + Heading */}
        <div>
          <h2 className="text-4xl md:text-5xl font-extrabold font-['Playfair_Display','serif'] text-gray-900 mb-4">
            About Us
          </h2>
          {/* <p className="text-sm text-gray-500 mb-6">Home / About Us</p> */}
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed max-w-3xl">
            The Birth Injury Justice Center was created as a helpful resource
            focused on victims of birth injuries and their families. Our mission
            is to provide legal information and guidance and serve all families
            whose lives have been affected by birth injuries.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          <div className="bg-[#023437]  text-white rounded-xl px-6 py-8 text-center shadow-md">
            <p className="text-3xl font-bold">1.8K</p>
            <p className="mt-2 text-base">families helped and counting</p>
          </div>
          <div className="bg-teal-100 text-[#023437]  rounded-xl px-6 py-8 text-center shadow-md">
            <p className="text-3xl font-bold">$1M</p>
            <p className="mt-2 text-base">average medical malpractice payout</p>
          </div>
          <div className="bg-[#023437]  text-white rounded-xl px-6 py-8 text-center shadow-md">
            <p className="text-3xl font-bold">24/7</p>
            <p className="mt-2 text-base">availability to support you</p>
          </div>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-3 gap-10 items-start">
          {/* Left Side */}
          <div className="lg:col-span-2 space-y-6">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900">
              About the Child Birth Injury Justice Center
            </h3>
            <div className="grid md:grid-cols-2 gap-6 items-start">
              {/* Text */}
              <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
                <p>
                  The Birth Injury Justice Center at childbirthinjuries.com was
                  founded in 2003 by a team of legal professionals with firsthand
                  experience in taking action against the horrible consequences of
                  medical negligence.{" "}
                  <span className="font-semibold text-gray-900">
                    We are devoted to educating families
                  </span>{" "}
                  who have a child diagnosed with a birth injury or may be showing
                  signs of a birth injury.
                </p>
                <p>
                  Many birth injuries could have been prevented with proper care
                  before, during, or after birth and delivery. If your child
                  experienced a physical injury, you have the right to know what
                  happened and what you can do next.
                </p>
                <p>
                  <span className="font-semibold text-gray-900">
                    Our goal is to empower families to get the legal help they need
                    and deserve.
                  </span>{" "}
                  Filing a birth injury lawsuit can result in compensation that can
                  help you and your family with the ongoing costs of your child’s
                  care and treatment.
                </p>
              </div>

              {/* Image */}
              <div>
                <img
                  src={img}
                  alt="Birth Injury Support"
                  className="w-full h-auto rounded-xl object-cover shadow-md"
                />
              </div>
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="bg-teal-50 border-l-4 border-[#023437]  rounded-xl p-6 shadow-md">
            <h4 className="text-xl font-bold text-gray-900 mb-4">
              Our purpose is to help you:
            </h4>
            <ul className="space-y-4 text-gray-700 text-base">
              <li className="flex items-start gap-3">
                <span className="text-[#023437]  text-xl">💬</span>
                <span>Understand what happened to your child</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#023437]  text-xl">👩‍⚕️</span>
                <span>Find available treatment options</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#023437]  text-xl">📑</span>
                <span>
                  Learn about financial and health care benefits
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutOne;
